<template>
  <div id="tenant">
    <div class="title">租户管理</div>
    <div class="tenant-container">
      <div class="container-tip">
        <svg-icon icon-class="icon-tips" class="icon-tips" />
        <ul>
          <svg-icon icon-class="tips-bg" class="icon-tips-bg" v-if="showTips" />
          <li class="tips-tit">
            小贴士
            <i
              class="el-icon-caret-top tips-btn"
              v-if="showTips"
              @click="showTip"
            ></i>
            <i
              class="el-icon-caret-bottom tips-btn"
              v-else
              @click="showTip"
            ></i>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>
             一个租户可以关联一个版本，关联版本后，该版本下的功能对本租户开放
            </div>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>
              创建租户时，请按照实际业务场景进行功能配置
            </div>
          </li>
        </ul>
      </div>
      <div class="container-main">
        <div class="main-left">
          <div class="left-operation">
            <div class="operation-btn">
              <el-tooltip placement="top" popper-class="custom-tooltip" effect="light">
                <div slot="content">添加租户</div>
                <div @click="addTenant">
                  <svg-icon icon-class="add-ico" class="btn-add" />
                </div>
              </el-tooltip>
              <el-tooltip placement="top" popper-class="custom-tooltip" effect="light">
                <div slot="content">删除</div>
                <div @click="delTenant">
                  <svg-icon icon-class="del-ico" class="btn-del" />
                </div>
              </el-tooltip>
            </div>
            <el-input
              class="operation-search"
              placeholder="请输入租户名称"
              suffix-icon="el-icon-search"
              v-model="search"
              clearable
              v-if="tenantList.length"
              @keyup.enter.native="enterSearch"
            ></el-input>
          </div>
          <ul class="tenant-list">
            <li
              class="tenant"
              v-for="(item,index) in tenantList"
              :key="index"
              :class="{'active-tenant':tenantOpration==index}"
              @click="selectTenant(index,item)"
            >
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
       
        <div class="main-right" v-if="tenantList.length||operation=='create'">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basic-info">
              <basic-info
                ref="basicInfo"
                :operation="operation"
                :tenantInfo="tenantInfo"
                @newTenantInfo="changeTenantInfo($event)"
                @updateTenantInfo = "updateTenantInfo($event)"
              ></basic-info>
            </el-tab-pane>
            <el-tab-pane label="功能配置" name="features">
              <features :id="tenantInfo.id"></features>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="main-right-none" v-if='noneTenant&&operation!="create"'>
          <img src="@/assets/image/none-img.png" alt="">
          <div class="none-tips">当前暂无租户，单击下面“立即添加”按钮添加新租户。</div>
          <el-button type="primary" @click="addTenant">立即添加</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicInfo from "./basic-info";
import features from "./features";
import {
  getTenants,
  getTenantInfo,
  deleteTenant,
  creatTenant,
  updateTenant,
} from "@/http/api/tenants";
import { deepCopy } from "@/utils/deepCopy";


export default {
  components: {
    basicInfo,
    features,
  },
  data() {
    return {
      activeTab: "basic-info",
      search: "",
      tenantOpration: 0,
      tenantList: [],
      operation: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      noneTenant:false,
      tenantInfo: {},
      tenants: {},
      tenantNode: {},
      showTips: true,
      permissions: this.$store.getters.permissions,
    };
  },
  mounted() {
    this.getTenantList();
  },
  methods: {
    showTip() {
      this.showTips = !this.showTips;
    },
    enterSearch(){
      //console.log(1515,window.event);
      var evt = window.event || e;
      //console.log(evt, 66666);
      if (evt.keyCode == 13) {
        // 回车事件
        this.getTenantList();
      }
    },
    getTenantList() {
      let query={
        filter:this.search,
        MaxResultCount:100,
      }
      console.log(query,999);
      getTenants(query).then((res) => {
        this.tenantList = res.result.items;
        let id = this.tenantList.length ? this.tenantList[this.tenantOpration].id : ''
        //console.log(id,11111);
        this.noneTenant = this.tenantList.length==0?true:false
        this.getTenantDetails(id)
      });
    },
    selectTenant(index, item) {
      this.tenantOpration = index;
      this.getTenantDetails(item.id)
      this.operation = "checked";
    },
    getTenantDetails(id){
      getTenantInfo(id).then(res=>{
        //console.log(res,123123);
        this.tenantInfo = deepCopy(res.result)
      })
    },
    // 删除节点
    delTenant() {
      if (this.permissions["RocketSaas.Tenants.Delete"]) {
        this.$confirm(
          `是否删除${this.tenantList[this.tenantOpration].name}？`,
          `删除${this.tenantList[this.tenantOpration].name}`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            deleteTenant(this.tenantList[this.tenantOpration].id)
              .then((res) => {
                if (res.code == 10200) {
                  this.getTenantList();
                  this.$message.success({ message: res.message });
                } else {
                  this.$message.warning({ message: res.message });
                }
              })
              .catch((err) => {
                this.$message.error({ message: err.message });
              });
          })
          .catch(() => {
            this.$message({
              message: "取消删除",
              showClose: true,
            });
          });
      } else {
        this.$message.warning({
          message: `您暂无删除租户权限`,
          showClose: true,
        });
      }
    },
    addTenant() {
      if (this.permissions["RocketSaas.Tenants.Create"]) {
        this.activeTab = "basic-info";
        this.operation = "create";
        this.tenantInfo = {
        };
      } else {
        this.$message.warning({
          message: `您暂无创建租户权限`,
          showClose: true,
        });
      }
    },
    changeTenantInfo() {
      this.getTenantList();
      this.tenantUpdataInfo = {};
      this.operation = "checked";
    },
    updateTenantInfo(val){
      this.getTenantList();
      this.tenantInfo = val
      this.operation = "checked";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
#tenant {
  min-height: calc(100vh - 50px);
  // overflow-y: auto;
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 17px 20px 17px;
    background: rgba(255, 255, 255, 1);
  }

  .svg-icon {
    cursor: pointer;
  }

  .tenant-container {

    .container-tip {
      @include flex(row, flex-start);
      margin-bottom: 20px;
      padding: 20px;
      font-size: 12px;
      font-weight: 500;
      background: #fff;
      .icon-tips {
        color: $--color-primary;
        padding: 10px 0;
      }
      ul {
        margin: 0;
        position: relative;
        padding-left: 10px;
        width: 100%;
        .icon-tips-bg {
          position: absolute;
          right: 0px;
          bottom: -94px;
          font-size: 250px;
        }
        li {
          @include flex(row, center);
          margin-bottom: 10px;
          width: 100%;
          span {
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
            padding: 2px;
            background: #111;
          }
        }
        .tips-tit {
          justify-content: space-between;
          .tips-btn {
            position: relative;
            z-index: 99;
            padding: 10px;
            cursor: pointer;
          }
        }
        li:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .container-main {
      display: flex;
      // padding: 20px;
      min-height: calc(100vh - 220px);
     
      .main-left {
        border-radius: $--border-radius-base;
        margin-right: 20px;
        padding: 20px;
        width: 315px;
        background: #fff;

        .left-operation {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 50px;

            .btn-add {
              width: 10px;
              height: 10px;
            }

            .btn-del {
              width: 16px;
              height: 16px;
              color: #888;
            }
          }

          .operation-search {
            width: 220px;
            height: 30px;
          }
        }
        .tenant-list {
          padding-inline-start: 0;
          text-align: left;
          .tenant {
            @include flex(row, center);
            width: 305px;
            height: 35px;
            padding-left: 9px;
            font-size: 12px;
            cursor: pointer;
            color: #000000;
          }
          .active-tenant {
            background: #e5e5e5;
          }
        }
      }
      .main-right  {
        border-radius: $--border-radius-base;
        padding: 20px;
        overflow: hidden;
        width: calc(100% - 354px);
        background: #fff;

        ::v-deep .el-tabs {
          width: calc(100% + 10px);
          position: relative;
          right: 10px;
          .el-tabs__header{
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0)
          }
          .el-tab-pane {
            min-height: calc(100vh - 299px);
          }
        }
      }
      .main-right-none{
        @include flex(column,center);
        justify-content: center;
        padding: 20px;
        width: calc(100% - 354px);
        background: #fff;
        img{
          margin-bottom: 10px;
          width: 40%;
          height: auto;
        }
        .none-tips{
          margin-bottom: 10px;
          color: #888888;
        }
      }
    }
  }

  @media (max-width: 1600px) {
    .tenant-container {
      padding: 20px;
    }
  }

  @media (min-width: 1600px) and (max-width: 1920px) {
    .tenant-container {
      padding: 20px 100px;
    }
  }

  @media (min-width: 1920px) {
    .tenant-container {
      padding: 20px 180px;
    }
  }
}
</style>